import { QueryFunctionContext } from "@tanstack/react-query";
import { ArticleModel } from "./Models";
import ApiHttpClient from "@/HttpClient";

export interface ProductsListResponse {
  totalCount: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  items: ArticleModel[]
}

export interface ProductResponse extends ArticleModel { }

export const fetchProduct = async ({ queryKey }: QueryFunctionContext) => {
  const [, productId] = queryKey;
  const {data, status, statusText} = await ApiHttpClient().get<ProductResponse>(`/article/${productId}`, {});

  console.log(`Status ${status} ${statusText}`);
  console.log(JSON.stringify(data, null, 4));
  return data;
}